import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { Menu } from "./api-interfaces/menu.interface";

@Injectable({
    providedIn: 'root'
})
export class APIMenuService {
    ApiURL: string = "";
    constructor(private http: HttpClient) {
        this.ApiURL = environment.apiUrl + 'Menu/';
    }

    public get(userEmail: string,token:string,state:number): Observable<Menu>{
        
        const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
        const requestOptions = {
          headers: headers,
        };
         
        return this.http.get<Menu>(this.ApiURL + encodeURIComponent(userEmail)+ `/${String(state)}`, requestOptions);
    }
}
